export const nftsQueryInvalidationDelay = 1000;
